const workingContextTypesMap = {
  cart: 'cart',
  run_test: 'run_test',
  courier_service: 'courier_service',
  diets: 'diets',
  training_cards: 'training-cards',
}
export default workingContextTypesMap
